<template>
    <AppModal ref="Modal" :title="$t('labels.export')" @on-hide="hide">
        <div class="modal-body pb-0">
            <p>{{ $t('labels.export_products_modal_description') }}</p>
            <ol class="list">
                <li>{{ $t('labels.export_products_step1') }}</li>
                <li>{{ $t('labels.export_products_step2') }}</li>
                <li>{{ $t('labels.export_products_step3') }}</li>
            </ol>
            <FormGroup :label="$t('labels.type')" required>
                <AppSelect
                    @update:model-value="type = $event"
                    :model-value="type.value"
                    :selected-value="type.label"
                    :options="options"
                    option-key="value"
                    option-value="label"
                />
            </FormGroup>
        </div>
        <div class="modal-footer">
            <AppButton @click="createExport" color="indigo">
                {{ $t('buttons.export') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import AppSelect from '../../../../components/new/form/select/AppSelect.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../services/HttpClient';
import { IntegrationServiceEnum } from '../../../enums/IntegrationServiceEnum';

export default {
    name: "ExportProductsModal",
    components: {
        AppModal, FormGroup, AppSelect, AppButton
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            type: { value: 'file-1', label: 'XML' }
        }
    },
    methods: {
        show() {
            this.$refs.Modal.show();
        },
        hide() {
            this.$refs.Modal.hide();
            this.type = { value: 'file-1', label: 'XML' };
        },
        createExport() {
            let requestBody = {
                type: this.type.value
            };

            httpClient.post(`/integrations/${this.$route.params.integrationUuid}/exports`, requestBody).then(() => {
                this.$emit('export:started');
            })

            this.hide();
        }
    },
    computed: {
        options() {
            let options = [
                { value: 'file-1', label: 'XML' },
            ];

            if (this.integration.service === IntegrationServiceEnum.ROZETKA) {
                options.push({ value: 'file-2', label: 'Excel' });
            }

            return options;
        }
    }
}
</script>